import React from "react";

function article_1() {
	return {
		date: "10 Apr 2024",
		title: "You will see my upcoming articles here",
		description:
			"I am working on some exciting upcoming articles for the future stay tuned for the future updates.",
		keywords: [
			"The Benefits of Cloud Computing",
			"Tharindu",
			"Tharindu N",
			"Tharindu Nayanajith",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">Content of article 1</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

const defaultArticle = [article_1];

export default defaultArticle;
